// src/models/landing-page.js
import api from '../utils/contentful'

// This is the ID of the landing
// page we've created earlier.
export const InfoButtonId = '5B5PctuYze1x2AxBlyCP1z'

// The LandingPage class returns a clean
// LandingPage object with only the data we need.
export class InfoButton {
  constructor({ id = null, title = '', url = 'null' } = {}) {
    this.id = id
    this.title = title
    this.url = url
  }
}

// We use an adapter to bring the API response
// from the Contentful API into the correct format
// for our LandingPage class.
export function responseAdapter({ fields, sys }) {
  return new InfoButton({ ...fields, ...sys })
}

// We wrap the Contentful API client to format
// the response exactly the way we like it.
export default {
  async getData() {
    return responseAdapter(await api.getEntry(InfoButtonId))
  }
}
